import axiosApi from "api/root.api";

export const visitGet = async () => {
  const urlEnd = "/publish/v1/product/visit/currentMonth";
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
